const HaveFunInitialText ="This is your opportunity to take a break and have some fun. " +
    "Several options are displayed below that will be fun.  Choose the one that sounds best " +
    "to you."
        
export default HaveFunInitialText 
 